import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Home, Sun, Sparkles, CalendarCheck, HelpCircle } from "lucide-react";

const ServiceRibbon = ({ leads = [], onServiceClick, selectedService = null }) => {
  // Calculate service counts from the provided leads array
  const serviceCounts = leads.reduce((acc, lead) => {
    const service = lead.service || 'No Service';
    acc[service] = (acc[service] || 0) + 1;
    return acc;
  }, {});

  // Ensure all service types are present, even with 0 count
  const allServices = {
    'Dog Boarding': serviceCounts['Dog Boarding'] || 0,
    'Dog Daycare': serviceCounts['Dog Daycare'] || 0,
    'Both Boarding and Daycare': serviceCounts['Both Boarding and Daycare'] || 0,
    'Schedule A Tour': serviceCounts['Schedule A Tour'] || 0,
    'No Service': serviceCounts['No Service'] || 0
  };

  // Modern gradient styles matching Follow-Up Queue
  const serviceStyles = {
    'Dog Boarding': {
      gradient: 'from-blue-500 to-indigo-600',
      ring: 'ring-blue-300',
      textLight: 'text-blue-100',
      icon: Home
    },
    'Dog Daycare': {
      gradient: 'from-emerald-500 to-green-600',
      ring: 'ring-emerald-300',
      textLight: 'text-emerald-100',
      icon: Sun
    },
    'Both Boarding and Daycare': {
      gradient: 'from-purple-500 to-indigo-600',
      ring: 'ring-purple-300',
      textLight: 'text-purple-100',
      icon: Sparkles
    },
    'Schedule A Tour': {
      gradient: 'from-amber-500 to-orange-600',
      ring: 'ring-amber-300',
      textLight: 'text-amber-100',
      icon: CalendarCheck
    },
    'No Service': {
      gradient: 'from-gray-500 to-slate-600',
      ring: 'ring-gray-300',
      textLight: 'text-gray-100',
      icon: HelpCircle
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
      {Object.entries(allServices).map(([service, count]) => {
        const isSelected = selectedService === service;
        const style = serviceStyles[service];
        const IconComponent = style.icon;
        
        return (
          <Card
            key={service}
            onClick={() => onServiceClick && onServiceClick(service)}
            className={`bg-gradient-to-br ${style.gradient} text-white border-0 shadow-lg cursor-pointer transition-all duration-200 ${
              isSelected ? `ring-4 ${style.ring} scale-105` : 'hover:scale-102 hover:shadow-xl'
            }`}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className={`${style.textLight} text-xs font-medium`}>{service}</p>
                  <p className="text-3xl font-bold mt-1">{count}</p>
                </div>
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <IconComponent className="w-5 h-5" />
                </div>
              </div>
              {isSelected && (
                <p className={`${style.textLight} text-xs mt-2`}>✓ Active filter</p>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ServiceRibbon;
